import api from './api';

export interface AgentMessage {
  role: string;
  content: string;
  timestamp: string;
  metadata?: Record<string, unknown>;
}

export interface QueryRecord {
  index: number;
  query_text: string;
  constraints: Record<string, unknown>;
  result_count: number;
  returned_patent_ids: string[];
  timestamp: string;
}

export interface AgentResponse {
  success: boolean;
  message: string;
  phase: string;
  searches_in_phase: number;
  session_id?: string;
  claim_chart_exists?: boolean;
}

export interface ConversationResponse {
  session_id: string;
  conversation: AgentMessage[];
}

export interface QueryTableResponse {
  session_id: string;
  query_table: QueryRecord[];
}

class PatentSearchChatService {
  private baseUrl = '/patent-search-agent';

  async startSession(sessionId: string): Promise<AgentResponse> {
    const response = await api.post<AgentResponse>(`${this.baseUrl}/start/${sessionId}`);
    return response.data;
  }

  async sendMessage(sessionId: string, message: string, action?: string): Promise<AgentResponse> {
    const response = await api.post<AgentResponse>(`${this.baseUrl}/message/${sessionId}`, {
      message,
      action
    });
    return response.data;
  }

  async generateFeatures(sessionId: string, message?: string): Promise<AgentResponse> {
    return this.sendMessage(sessionId, message || "Please generate the Claim Chart features.", "generate_features");
  }

  async regenerateFeatures(sessionId: string, message?: string): Promise<AgentResponse> {
    return this.sendMessage(sessionId, message || "Please regenerate the Claim Chart features based on our conversation.", "regenerate_features");
  }

  async getConversation(sessionId: string): Promise<ConversationResponse> {
    const response = await api.get<ConversationResponse>(`${this.baseUrl}/conversation/${sessionId}`);
    return response.data;
  }

  async getQueryTable(sessionId: string): Promise<QueryTableResponse> {
    const response = await api.get<QueryTableResponse>(`${this.baseUrl}/query-table/${sessionId}`);
    return response.data;
  }
}

export const patentSearchChatService = new PatentSearchChatService();
